import type { ReactNode } from 'react'
import { cn } from '~/shadcn/lib/utils'

type Props = {
  label: string
  value: ReactNode
  valueClassName?: string
  size?: 'sm' | 'lg'
}

const valueSizeClasses = {
  sm: 'text-sm font-bold text-white',
  lg: 'text-base md:text-xl font-semibold text-foreground',
} as const

export function InfoField({
  label,
  value,
  valueClassName,
  size = 'sm',
}: Props) {
  return (
    <div className="flex flex-col gap-1">
      <span className="text-sm font-medium text-muted">{label}</span>
      <span className={cn(valueSizeClasses[size], valueClassName)}>
        {value}
      </span>
    </div>
  )
}
